import { render, staticRenderFns } from "./WordSelectBox.vue?vue&type=template&id=13b81f0c&"
import script from "./WordSelectBox.vue?vue&type=script&lang=js&"
export * from "./WordSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports